import createAsyncActions from 'shared/redux/helpers/create-async-actions';
import getItemsDealInfo from 'shared/utils/adapters/payments/items-deal-info';


const ACTIONS = createAsyncActions('SERVER.PAYMENTS.DEAL_INFO.GET');
export const NAMES = ACTIONS.NAMES;
const { START, SUCCESS, FAIL } = ACTIONS;

export default function () {
  return function (dispatch) {
    dispatch(START());

    return getItemsDealInfo()
      .then(result => {
        dispatch(SUCCESS({}, result));
        return result;
      })
      .catch(error => {
        dispatch(FAIL(null, error));
      });
  };
}



// WEBPACK FOOTER //
// ./src/shared/redux/server/actions/payments/get-items-deal-info.js